const toggleContent = () => {
  const toggles = document.querySelectorAll("[data-toggle]");

  toggles.forEach(toggle => {
    toggle.addEventListener("click", () => {
      const targetKey = toggle.getAttribute("data-toggle");
      const content = document.querySelector(`[data-toggle-content="${targetKey}"]`);
      const toggleTextContent = toggle.querySelector('span')
      if (!content) return;

      if (content.classList.contains("open")) {
        // Collapse
        content.style.maxHeight = content.scrollHeight + "px";
        requestAnimationFrame(() => {
          content.style.maxHeight = "0px";
        });
         toggleTextContent.textContent = theme.strings.seeMore || 'Show more';
      } else {
        // Expand
        content.style.maxHeight = content.scrollHeight + "px";
        toggleTextContent.textContent = theme.strings.seeLess || 'Show less';
      }

      content.classList.toggle("open");
    });
  });
}

const updateColorLabelOnHover = () => {
  const currentLabel = document.querySelector("[data-current-label]");
  const variants = document.querySelectorAll(".product-variant");

  if (!currentLabel || !variants.length) return;

  const defaultLabel = currentLabel.textContent;

  variants.forEach(variant => {
    const label = variant.getAttribute("data-label");

    variant.addEventListener("mouseenter", () => {
      if (label) currentLabel.textContent = label;
    });

    variant.addEventListener("mouseleave", () => {
      currentLabel.textContent = defaultLabel;
    });
  });
};

const updateBundleTitleOnHover = () => {
  const currentTitle = document.querySelector("[data-current-item-title]");
  const bundleItems = document.querySelectorAll(".bundles-container__img");

  if (!currentTitle || !bundleItems.length) return;

  const defaultTitle = currentTitle.textContent;

  bundleItems.forEach(item => {
    const title = item.getAttribute("data-product-title");

    item.addEventListener("mouseenter", () => {
      if (title) currentTitle.textContent = title;
    });

    item.addEventListener("mouseleave", () => {
      currentTitle.textContent = defaultTitle;
    });
  });
};

const HighlightsSlider = (() => {
  let slider = null;

  const init = () => {
    const wrapper = document.querySelector('.highlights-grid');
    if (!wrapper) return;

    const items = wrapper.querySelectorAll('.highlights-grid__item');
    const itemCount = items.length;
    if (itemCount <= 1) return;

    const isMobile = window.innerWidth <= 768;
    const shouldInitOnDesktop = itemCount >= 5;

    // ✅ Initialize conditions
    if ((isMobile || shouldInitOnDesktop) && !slider) {
      slider = new Flickity(wrapper, {
        adaptiveHeight: false,
        initialIndex: 0,
        pageDots: true,
        wrapAround: false,
        cellAlign: 'left',
        prevNextButtons: false,
        groupCells: true,
        contain: true,
      });
    } 
    // ✅ Destroy when not mobile and less than 5 items
    else if (!isMobile && itemCount < 5 && slider) {
      slider.destroy();
      slider = null;
    }
  };

  // Optional: debounce resize for performance
  const resizeHandler = () => {
    clearTimeout(window._highlightsSliderTimeout);
    window._highlightsSliderTimeout = setTimeout(() => {
      init();
    }, 150);
  };

  const setup = () => {
    init();
    window.addEventListener('resize', resizeHandler);
  };

  return { setup };
})();


document.addEventListener("DOMContentLoaded", () => {
  toggleContent();
  updateColorLabelOnHover();
  updateBundleTitleOnHover();
  HighlightsSlider.setup();
});